import React, { useState } from "react";

import validator from "validator";

import { Oval } from "react-loader-spinner";

import { useNavigate } from "react-router-dom";

import "tachyons";

import "./footer.css"

export default function Footer({

}) {
  const navigate = useNavigate();
  //states
  const [email, setEmail] = useState("");

  const [emailError, setEmailError] = useState("");
  const [flag, setFlag] = useState(null);
  const [foundErr, setFoundErr] = useState(null);
  const [isLoading, setIsLoading] = useState(null);

  const [status, setStatus] = useState("idle"); 
  // idle | loading | success | error
  const [message, setMessage] = useState("");

  const handleSubscribe = async () => {
    if (!validator.isEmail(email)) {
      setStatus("error");
      setMessage("Please enter a valid email address.");
      return;
    }

    setStatus("loading");
    setMessage("");

    try {
      const res = await fetch("https://api.terraweb.africa/subscribe", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();

      if (!res.ok) {
        setStatus("error");
        setMessage(data.message || "Failed to subscribe.");
        return;
      }

      setStatus("success");
      setMessage("You’re subscribed! Check your email for confirmation.");
      setEmail("");

    } catch (e) {
      setStatus("error");
      setMessage("Server error. Please try again later.");
    }
  };

  const validateEmail = () => {
    var emailnew = email;

    if (validator.isEmail(emailnew)) {
      setEmailError("valid");
      setFlag(1);
    } else {
      setEmailError("not valid");
      setFlag(2);
    }
  };
  function onEmailChange(event) {
    if (email.length >= 1) {
      setFlag(1);
    } else {
      setFlag(2);
    }
    setEmail(event.target.value);
  }
  return (
   

    <footer className="footer-section">
      <div className="footer-content">
        {/* Logo */}
        <div className="footer-block">
          <img
            src="img/LOGO-FAVCON.png"
            alt="Terraweb logo"
            className="footer-logo"
          />
        </div>

        {/* Newsletter */}
     <div className="newsletter">
      <input
        type="email"
        className={`newsletter-input ${status === "error" ? "error" : ""}`}
        placeholder="Enter your email"
        value={email}
        onChange={(e) => {
          setEmail(e.target.value);
          setStatus("idle");
        }}
      />

      <button
        className="newsletter-button"
        onClick={handleSubscribe}
        disabled={status === "loading"}
      >
        {status === "loading" ? (
          <span className="loader"></span>
        ) : (
          "Subscribe"
        )}
      </button>

      {status === "error" && (
        <p className="footer-error animate-fade">{message}</p>
      )}

      {status === "success" && (
        <p className="footer-success animate-fade">{message}</p>
      )}
    </div>

        {/* Social */}
        <div className="footer-block">
          <h4 className="footer-heading">Get in Touch</h4>
          <button
            className="social-button"
            onClick={() => window.open("https://facebook.com/", "_blank")}
          >
            <svg
              className="social-icon"
              fill="currentColor"
              viewBox="0 0 16 16"
            >
              <path d="M15.117 0H.883C.395 0 0 .395 0 .883v14.234c0 .488.395.883.883.883h7.663V9.804H6.46V7.39h2.086V5.607c0-2.066 1.262-3.19 3.106-3.19.883 0 1.642.064 1.863.094v2.16h-1.28c-1 0-1.195.476-1.195 1.176v1.54h2.39l-.31 2.416h-2.08V16h4.077c.488 0 .883-.395.883-.883V.883C16 .395 15.605 0 15.117 0" />
            </svg>
            <span className="ml2">Facebook</span>
          </button>
        </div>
      </div>
      <div className="footer-divider" />


      {/* Terms and copyright */}

      <div className="footer-bottom">
        <span
          className="footer-link"
          onClick={() => navigate("/termsofservice")}
        >
          Terms of Service
        </span>
        <p className="footer-copy">&copy; 2025 Terrawebgroup. All rights reserved.</p>
      </div>
    </footer>
  );
}

// export default Footer;
